// Rotate cursor component for token rotation

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Rotate cursor component
 * Displays a rotation icon at the cursor position during token rotation
 */
class RotateCursor extends BaseComponent {
  static properties = {
    show: { type: Boolean },
    x: { type: Number },
    y: { type: Number },
  };

  static styles = css`
    :host {
      display: block;
    }

    .rotate-cursor {
      position: fixed;
      pointer-events: none;
      z-index: 10000;
      transform: translate(-50%, -50%);
      color: white;
      filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.8));
    }
  `;

  constructor() {
    super();
    this.show = false;
    this.x = 0;
    this.y = 0;
  }

  _renderRotateCwIcon() {
    return html`
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
        <path d="M21 3v5h-5" />
      </svg>
    `;
  }

  render() {
    if (!this.show) {
      return html``;
    }

    return html`
      <div class="rotate-cursor" style="left: ${this.x}px; top: ${this.y}px;">${this._renderRotateCwIcon()}</div>
    `;
  }
}

customElements.define('rotate-cursor', RotateCursor);
